import { NotScrollJournalPage } from "../../components/frontComponents/notScrollJournalPage/NotScrollJournalPage";
import DoctorLeft from "../../assets/images/MealMood/doctor_left.png";
import DoctorRight from "../../assets/images/MealMood/doctor_right.png";
import DoctorBig from "../../assets/images/MealMood/doctor_big.png";
import styles from "./styles.module.scss";
import Left from "../../assets/images/MealMood//metabolism_left.png";
import { useEffect, useState } from "react";
import { Button } from "components/frontComponents/button/Button";
import { useNavigate } from "react-router-dom";
import Right from "../../assets/images/MealMood/metabol_right.png";
import { RouterPathEnum } from "../../shared/enums/commonEnums";
import CalendarWrap from "./calendar/CalendarWrap";
import LineChartGraphic from "./LineChart/LineChartGraphic";
import AreaChartFillByValueGraphic from "./areaChartGraphic/AreaChartGraphic";
import PositiveAndNegativeBarChart from "./PositiveAndNegativeBarChart/PositiveAndNegativeBarChart";

export const MetabolismPage = () => {
  const [pageStatus, setPageStatus] = useState<number>(1);
  const [selectedDates, setSelectedDates] = useState<string[] | null>([]);

  const navigate = useNavigate();
  useEffect(() => {
    if (!selectedDates || selectedDates.length === 0) {
      setPageStatus(1);
    } else {
      setPageStatus(2);
    }
  }, [selectedDates]);

  const handleDateChange = (dates: string[]) => {
    setSelectedDates(dates);
    // console.log("Получены даты от CalendarWrap:", dates);
  };
  return (
    <div className={styles.metabolismpage}>
      <NotScrollJournalPage
        leftContent={
          <div className={styles.containerLeft}>
            <div className={styles.calendarholder}>
              <CalendarWrap onDateChange={handleDateChange} />
              {/* <Button
                viewVariant="primary"
                className={styles.button}
                text="применить"
                onClick={() => navigate(RouterPathEnum.Auth)}
              /> */}
            </div>
            {pageStatus === 1 && <img src={Left} alt="" />}
            {pageStatus === 2 && (
              <div className={styles.leftholder}>
                <div className={styles.explanationcontainer}>
                  <div className={styles.leftleft}>
                    <div className={styles.photoholder}>
                      <img src={DoctorLeft} alt="" className={styles.photo} />
                    </div>

                    <h3 className={styles.doctortext}>
                      Анаболические процессы (синим цветом) - в твоем организме
                      много энергии и веществ, они расходуются на построение
                      новых тканей, ты набираешь массу
                    </h3>
                  </div>
                  <div className={styles.leftright}>
                    <h3 className={styles.doctortext}>
                      Катаболические процессы (оранжевым цветом) - в твоем
                      организме энергия и вещества расходуются из тканей
                      организма, ты теряешь массу
                    </h3>
                    <div className={styles.photoholder}>
                      <img src={DoctorRight} alt="" className={styles.photo} />
                    </div>
                  </div>
                </div>
                <div className={styles.leftmiddle}>
                  <AreaChartFillByValueGraphic />
                  <div className={styles.doctorphotoholder}>
                    <img
                      src={DoctorBig}
                      alt=""
                      className={styles.doctorphoto}
                    />
                  </div>
                </div>
              </div>
            )}
          </div>
        }
        rightContent={
          <div className={styles.containerRight}>
            {pageStatus === 1 && (
              <div className={styles.holder}>
                <img src={Right} alt="" />
                <Button
                  viewVariant="primary"
                  className={styles.buttonBottom}
                  text="вернуться назад"
                  onClick={() => navigate(-1)}
                />
              </div>
            )}
            {pageStatus === 2 && (
              <div className={styles.holder}>
                <div className={styles.grapicsholder}>
                  <div className={styles.grapicholder}>
                    <LineChartGraphic />
                    <div className={styles.text}>
                      Обрати внимание, что в твоем рационе слишком много
                      углеводов. Молодец, что поддерживаешь баланс белков и
                      жиров.
                    </div>
                  </div>
                  <div className={styles.grapicholder}>
                    <div className={styles.text}>
                      Ты потребляешь намного больше энергии, чем тратишь.
                      Соответствует ли этот результат поставленной тобой цели?
                    </div>
                    <PositiveAndNegativeBarChart />
                  </div>
                </div>
                <div className={styles.buttonsholder}>
                  <Button
                    viewVariant="primary"
                    className={styles.buttonBottom}
                    text="детализация"
                    onClick={() => navigate("/profile/kbgu")}
                  />
                  <Button
                    viewVariant="primary"
                    className={styles.buttonBottom}
                    text="вернуться назад"
                    onClick={() => navigate(-1)}
                  />
                </div>
              </div>
            )}
          </div>
        }
      />
    </div>
  );
};
